import { getItem, removeItem, notify } from "@/utils";
import config from '@/config'
const { baseURL, contentType:configContentType, statusName, credentials, tokenHeaderName, tokenName, messageName } = config

const t = t => t


/**
 * 处理对应数据类型
 * @param { Object } data
 * @param { URLSearchParams | FormData }  container
 * @returns { URLSearchParams | FormData }
 */
function processData(data, container) {
	const preData = dataFormatter(data)
	for (const key in preData) {
		container.append(key, preData[key])
	}
	return container
}

/**
 * 参数扁平化处理
 * @param { * } data
 * @returns Object
 */
function dataFormatter(data) {
	const isPrimate = value => typeof value !== 'object' || value instanceof Blob
	const processData = {}
	const doFormatter = (data, parentKey = '') => {
		if (isPrimate(data)) return processData[parentKey] = data
		for (const key in data) {
			const k = parentKey === '' ? key : `[${key}]`
			const value = data[key]
			if (isPrimate(value)) {
				processData[parentKey + k] = value
			} else if (Array.isArray(value)) {
				value.forEach((item, index) => {
					const combinedKey = parentKey + k + `[${index}]`
					isPrimate(item) ? (processData[combinedKey] = item) : doFormatter(item, combinedKey)
				})
			} else if (value.constructor === Object) {
				doFormatter(value, parentKey + k)
			} else {
				doFormatter(JSON.parse(JSON.stringify(value)), parentKey + k)
			}
		}
		return processData
	}
	return doFormatter(data)
}

/**
 * 基础请求
 * @param { string } url 请求地址
 * @param { IRequestOptions } options 请求配置
 * @returns { Promise<IResponse> }
 */
function request(url, options) {
	return new Promise((resolve, reject) => {
		fetch(url, options).then(res => {
			switch (options.responseType) {
				case "blob":
					return res.blob()
				case "arrayBuffer":
					return res.arrayBuffer()
				case "text":
					return res.text()
				default:
					return res.json()
			}
		}).then(res => {
			// 非json不判斷status
			if (options.responseType && options.responseType !== "json") {
				return resolve(res)
			}

			//	json判斷狀態是否成功
			switch (res[statusName]) {
				case "success":
					resolve(res)
					break;
				case "noauth":
					notify.error(t('權限不足'))
					reject({ status: 'noauth' })
					break;
				case "expired":
					removeItem(tokenName)
					notify.error(t('登入憑證過期,請重新登入'))
					reject({ status: 'expired' })
					break;
				default:
					notify.error(res[messageName])
					reject(res)
			}
		}).catch(e => {
			notify.error('網絡錯誤,請稍後重試')
			reject(e)
		})
	})
}

/**
 * get 請求
 * @param { string } url 請求地址
 * @param { Object } data 請求參數
 * @param { IRequestOptions } options 請求配置
 * @returns {Promise<IResponse>}
 */
export function get(url, data = {}, options = {}) {
	let path;
	try{
		path = new URL(baseURL + url)
	}catch (e){
		path = new URL(location.origin + '/' + location.pathname.replaceAll('/','') + url)
	}
	let search = path.search
	let params = new URLSearchParams(data).toString()
	if (search.trim() !== "") {
		if (params.trim() !== "") params = '&' + params
	} else {
		if (params.trim() !== "") search = '?'
	}
	url = path.origin + path.pathname + search + params
	return request(url, {
		...options,
		credentials,
		method: 'GET',
	})
}

/**
 * post 請求
 * @param { string } url 請求地址
 * @param { Object } data 請求參數
 * @param { IRequestOptions } options 請求配置
 * @returns {Promise<IResponse>}
 */
export function post(url, data = {}, options = {}) {
	if (!options.headers) options.headers = new Headers()
	const contentType = options.headers?.['Content-Type'] ?? configContentType
	if (contentType.startsWith("multipart/form-data")) {
		data = processData(data, new FormData())
		Reflect.deleteProperty(options.headers, 'Content-Type')
	} else if (contentType.startsWith("application/x-www-form-urlencoded")) {
		data = processData(data, new URLSearchParams())
	} else if (contentType.startsWith("application/json")) {
		data = JSON.stringify(data)
	}
	options.body = data
	options.headers.set(tokenHeaderName, getItem(tokenName) || '')
	return request(baseURL + url, {
		...options,
		credentials,
		method: 'POST',
		body: data
	})
}

export default request
